import subscribeAdminsAndSupervisors from "src/utils/subscribeAdminsAndSupervisors"
import { firestore as db } from "src/Firebase"

export const getEmpresa = async id => {
  if (id && id !== "") {
    const doc = await db.collection("empresas").doc(id).get()
    return { ...doc.data(), id: doc.id }
  }
  return { Color: "#092147" }
}

export const newEmpresa = data => db.collection("empresas").add(data)

export const updateEmpresa = (id, values) =>
  db.collection("empresas").doc(id).update(values)

export const getEmpresas = observer =>
  db.collection("empresas").onSnapshot(observer)

export const deleteEmpresaId = id => db.collection("empresas").doc(id).delete()

export const getConjuntos = Empresa =>
  db.collection("conjuntos").where("Empresa", "array-contains", Empresa).get()

export const getAllAdmins = subscribeAdminsAndSupervisors

export const getAllConjuntos = observer =>
  db.collection("conjuntos").onSnapshot(observer)

export const AddUserEmpresa = (uid, data) =>
  db
    .collection("usuarios")
    .doc(uid)
    .set({
      Nombre: data.Nombre || "",
      Apellido: data.Apellido || "",
      Cedula: data.Cedula || "",
      Correo: data.Correo || "",
      Telefono: data.Telefono || "",
      Roles: { empresa: true },
      ConjuntoUid: data.ConjuntoUid,
      isActive: true,
      Empresa: data.Empresa || "",
    })

export const UpdateUserEmpresa = (uid, data) =>
  db
    .collection("usuarios")
    .doc(uid)
    .update({
      Nombre: data.Nombre || "",
      Apellido: data.Apellido || "",
      Cedula: data.Cedula || "",
      Correo: data.Correo || "",
      Telefono: data.Telefono || "",
      ...(data.Empresa && data.Empresa !== ""
        ? {
            Empresa: data.Empresa,
            "Roles.empresa": true,
          }
        : {
            Empresa: "",
            "Roles.empresa": false,
          }),
    })

export const getAllUsersEmpresa = observer =>
  db
    .collection("usuarios")
    .where("Roles.empresa", "==", true)
    .onSnapshot(observer)

export const getUnidades = Empresa =>
  db
    .collection("conjuntos")
    .doc(Empresa)
    .collection("unidadesHabitacionales")
    .get()

export const getUsers = conjuntoID =>
  db
    .collection("usuarios")
    .where("ConjuntoUidResidencia", "==", conjuntoID)
    .get()
